export default function AboutHero() {
  return (
    <section className="relative min-h-[620px] flex items-center overflow-hidden" style={{ background: "#09245b" }}>
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=bold%20vibrant%20cartoon%20illustration%20of%20a%20cheerful%20lime-green%20rubbish%20removal%20van%20driving%20through%20a%20bright%20lush%20English%20countryside%20with%20rolling%20vivid%20green%20hills%20patchwork%20fields%20and%20a%20brilliant%20blue%20sky%20full%20of%20fluffy%20white%20clouds%2C%20vivid%20saturated%20flat%202D%20vector%20art%2C%20thick%20black%20outlines%2C%20lime%20green%20and%20navy%20blue%2C%20crisp%20bright%20storybook%20style%2C%20no%20text%20no%20people&width=1600&height=900&seq=about-hero-v30&orientation=landscape"
          alt="Cleario eco landscape"
          className="w-full h-full object-cover object-top opacity-20"
        />
        <div className="absolute inset-0" style={{ background: "linear-gradient(135deg, rgba(9,36,91,0.97) 0%, rgba(9,36,91,0.90) 50%, rgba(9,36,91,0.82) 100%)" }}></div>
      </div>

      <div className="relative max-w-screen-xl mx-auto px-6 lg:px-10 py-24 w-full">
        <div className="max-w-2xl">
          {/* Eyebrow */}
          <div className="inline-flex items-center gap-2 bg-cl-lime/20 border-2 border-cl-lime/40 rounded-full px-4 py-1.5 mb-7 mt-16">
            <span className="w-2 h-2 rounded-full bg-cl-lime inline-block"></span>
            <span className="text-cl-lime font-black text-xs uppercase tracking-widest">Our Story</span>
          </div>

          <h1 className="text-5xl lg:text-7xl font-black text-white leading-none mb-6">
            Rubbish removal<br />
            <span className="text-cl-lime">done right.</span>
          </h1>

          <p className="text-white/75 text-lg font-semibold leading-relaxed mb-10 max-w-xl">
            Cleario was built on a single belief — that getting rid of your rubbish shouldn&apos;t cost the planet. Since 2025 we&apos;ve been proving it, one van load at a time.
          </p>

          <div className="flex flex-wrap gap-4">
            <Link
              to="/book"
              className="inline-flex items-center gap-2 bg-cl-lime text-cl-dark font-black px-7 py-3.5 rounded-full text-sm cartoon-btn whitespace-nowrap"
            >
              <i className="ri-price-tag-3-line"></i>
              Get a quote
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 bg-white/15 border-2 border-white/30 text-white font-black px-7 py-3.5 rounded-full text-sm hover:bg-white/25 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line"></i>
              Talk to us
            </Link>
          </div>
        </div>
      </div>

      {/* Floating stats */}
      <div className="absolute bottom-0 right-0 left-0">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
          <div className="flex flex-wrap justify-end gap-4 pb-8">
            {[
              { value: "2025", label: "Founded" },
              { value: "5 Areas", label: "W. Midlands Coverage" },
              { value: "200+", label: "Reviews" },
              { value: "95%+", label: "Recycled" },
            ].map((s) => (
              <div key={s.label} className="bg-white/10 backdrop-blur-sm border-2 border-white/20 rounded-2xl px-5 py-3 text-center">
                <p className="text-cl-lime font-black text-xl">{s.value}</p>
                <p className="text-white/70 text-xs font-semibold">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}